<template>
  <div
    id="RealNameAuthBtn"
    style="display: inline;float: left;width: 54%;"
  >
    <div
      v-if="(orgInfo.departType==1 || orgInfo.departType==3) && flagObj.authBtnStatus==0"
      style="font-size: 12px;display: inline;"
    >
      <el-button
        :loading="flagObj.realNameButtonLoading"
        style="float: right;margin-right: 15px;"
        @click="applyRealName()"
        class="eb-button-orange eb-button-larger"
      >提交实名认证</el-button>
    </div>
    <div
      v-if="(orgInfo.departType==1 || orgInfo.departType==3) && flagObj.authBtnStatus==1 && orgInfo.authStatus!=2"
      style="font-size: 12px;display: inline;"
    >
      <el-button
        style="float: right;margin-right: 15px;"
        @click="confirmCancelRealName()"
        class="el-button el-button eb-button-orange eb-button-small el-button--default"
      >更新实名信息</el-button>
    </div>
    <a
      style="display:none"
      id="applyRealName"
    > 获取验证码</a>
    <WeixinQRCodePay
      ref="weixinQRCodePay"
      @paymentComplete="wxPaymentComplete"
      :isVisible.sync="weixinPay.isVisible"
    >
      <!-- <template slot="info">
        <div>{{checkedBusiOpptyList.length > 0 ? checkedBusiOpptyList[0].busiOpptyDesc : ''}}</div>
        <div>订单号:{{sysOrderNumber}}</div>
      </template> -->
      <!-- <template slot="info">
        <div class="weixinQRCodePayTitle">
          <div class="weixinQRCodePayTitle_left">{{authenticationTemplateInfo.desc}}易比得订单号：{{sysOrderNumber}}</div>
          <div class="weixinQRCodePayTitle_right">应付金额
            <span class="weixinQRCodePayTitle_right_price">{{authenticationTemplateInfo.price}}</span>元</div>
        </div>
      </template> -->
    </WeixinQRCodePay>
  </div>
</template>
<script>
import { applyRealName, cancelRealName } from '@/services/org/depart-service';
import moment from 'moment';
import $ from 'jquery';
import initGeetest from '@/plugins/gt';
import { geetest, information, queryPayInfo } from '@/services/org/depart-realname-service';
import eventBus from '@/plugins/event-bus';
export default {
  name: 'RealNameAuthBtn',
  props: {
    orgInfo: {},
    user: {},
    flagObj: {
      type: Object,
      required: true
    },
    myApprovalInfo: {}
  },
  components: {
    WeixinQRCodePay: () => import('@/components/weixin/pay/WeixinQRCodePay')
  },
  data() {
    let startDate = moment().format('YYYY/MM/DD');
    let endDate = moment()
      .add(1, 'y')
      .subtract(1, 'd')
      .format('YYYY/MM/DD');
    let dateDuration = startDate + '~' + endDate;
    let desc = '机构信息实名认证，有效期12个月（' + dateDuration + '）';
    return {
      isGeest: false,
      geetestUrl: {},
      hostName: location.hostname,
      cookies: '',
      price: '300.00',
      weixinPay: {
        isVisible: false
      },
      authenticationTemplateInfo: {
        desc: desc,
        price: '300.00'
      },
      // 实名支付信息
      realNamePayInfo: {
        orderType: 'SMRZ1804',
        departId: this.orgInfo.departId,
        content: '易比得合规采购云机构信息实名认证',
        amount: 1,
        departName: this.orgInfo.departName,
        startDate: startDate,
        endDate: endDate,
        busiOpptyDesc: desc
      },
      sysOrderNumber: '', // 系统订单号
      departId: this.$store.state.user.userInfo.departId,
      isAuthing: false
    };
  },
  watch: {
    'weixinPay.isVisible': {
      handler: function(newVal, oldVal) {
        if (!newVal) {
          if (!this.isAuthing) {
            this.flagObj.realNameButtonLoading = false;
            this.flagObj.authInfoStatus = false;
          }
        }
      }
    }
  },
  created() {
    this.initData();
    eventBus.$on('OrgApplyRealName', params => {
      this.applyRealName();
    });
    eventBus.$on('orgRealNameAuthenticationPay', () => {
      this.showWeixinPayDialog();
    });
    eventBus.$on('realNameBtnLoading', flag => {
      this.flagObj.realNameButtonLoading = flag;
      this.flagObj.authInfoStatus = false;
    });
  },
  methods: {
    async initData() {
      if (this.hostName.indexOf('360bid') !== -1) {
        this.geetestUrl = {
          geetest: '/depart/geetest/proxy',
          information: '/depart/information/proxy'
        };
      } else {
        this.geetestUrl = {
          geetest: '/depart/geetest/local',
          information: '/depart/information/local'
        };
      }
      try {
        let result = await geetest(this.geetestUrl.geetest);
        result = result.data;
        if (result.returnCode === '00') {
          this.isGeest = false;
        } else {
          var data = result.data;
          this.cookies = result.cookies;
          let _this = this;
          initGeetest(
            {
              gt: data.gt,
              challenge: data.challenge,
              offline: !data.success,
              new_captcha: data.new_captcha,
              product: 'bind',
              width: '300px'
            },
            _this.handlerGeetest
          );
          this.isGeest = true;
        }
      } catch (e) {
        this.myApprovalInfo.departName = '未查询到信息';
        this.isGeest = false;
      }
    },
    // 申请实名认证
    applyRealName() {
      this.flagObj.realNameButtonLoading = true;
      let _this = this;
      if (_this.orgInfo.creditCode == null || _this.orgInfo.creditCode === '') {
        _this.$message.error('请填写统一社会信用代码.');
        _this.flagObj.realNameButtonLoading = false;
        return;
      }
      if (_this.orgInfo.departName == null || _this.orgInfo.departName === '') {
        _this.$message.error('请填写企业名称.');
        _this.flagObj.realNameButtonLoading = false;
        return;
      }
      if (_this.orgInfo.businessLicense == null || _this.orgInfo.businessLicense === '') {
        _this.$message.error('请上传营业执照.');
        _this.flagObj.realNameButtonLoading = false;
      } else {
        _this.flagObj.authInfoStatus = true;
        _this.flagObj.authInfo = '';
        if (_this.busiTermEndStatus === 1) {
          _this.orgInfo.busiTermEnd = '2999-01-01';
        }
        if (_this.busiTermEndStatus === 1) {
          _this.orgInfo.busiTermEnd = moment(_this.orgInfo.busiTermEnd).format('YYYY-MM-DD');
        }
        _this.realNamePayStatus();
      }
    },
    // 保存实名认证信息
    async saveRealName() {
      console.info(this.myApprovalInfo, '99999999999999');
      var params = {
        departId: this.user.orgId,
        departName: this.orgInfo.departName,
        registerAddress: this.orgInfo.registerAddress,
        registerCapital: this.orgInfo.registerCapital,
        creditCode: this.orgInfo.creditCode,
        legalPerson: this.orgInfo.legalPerson,
        businessLicense: this.orgInfo.businessLicense,
        orgType: this.orgInfo.orgType,
        foundingDate: this.momentDate(this.orgInfo.foundingDate),
        busiTermStart: this.momentDate(this.orgInfo.busiTermStart),
        busiTermEnd: this.momentDate(this.orgInfo.busiTermEnd),
        regOffice: this.orgInfo.regOffice,
        approvalDate: this.momentDate(this.orgInfo.approvalDate),
        regStatus: this.orgInfo.regStatus,
        busiScope: this.orgInfo.busiScope,
        approvalInfo: JSON.stringify(this.myApprovalInfo)
      };
      params.isSendMsg = false; // 是否发送消息给部门成员
      try {
        let { data } = await applyRealName(params);
        if (data.returnCode === '01') {
          this.flagObj.authBtnStatus = 1;
          this.flagObj.authInfoStatus = true;
          eventBus.$emit('refreshOrgInfo', true);
          eventBus.$emit('realNameSubmitOrgInfo', '');
          this.$message.success('实名申请已提交，请等待运营方审核。');
        } else if (data.returnCode === '02') {
          this.$message.success('实名认证支付失败，请重新支付');
        } else {
          this.flagObj.authBtnStatus = 0;
          this.flagObj.authInfoStatus = true;
          this.$message.error('申请失败.');
          this.flagObj.realNameButtonLoading = false;
        }
        this.$root.layout.isLoading = false;
      } catch (error) {
        this.$message.error(error.message);
        this.flagObj.realNameButtonLoading = false;
      }
    },
    // 确认更新实名制信息
    confirmCancelRealName() {
      this.$confirm(
        '请注意，更新实名信息期间，您的企业将处于“未实名认证”状态。如果重新实名认证，将重新收取机构实名认证服务费300元/年。是否确认更新实名信息？',
        '',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'eb-confirm-button',
          cancelButtonClass: 'eb-confirm-button',
          type: '',
          center: true,
          showClose: false,
          customClass: 'eb-comfirm'
        }
      )
        .then(() => {
          this.cancelRealName();
        })
        .catch(() => {});
    },
    // 更新实名制信息
    async cancelRealName() {
      this.$root.layout.isLoading = true;
      let { data } = await cancelRealName();
      if (data.returnCode === '01') {
        this.flagObj.authBtnStatus = 0;
        this.flagObj.authStatusFlag = false;
        this.flagObj.authInfoStatus = false;
        eventBus.$emit('refreshOrgInfo', true);
        this.$message.success('解锁成功.');
      }
      this.$root.layout.isLoading = false;
    },
    // 格式化日期
    momentDate(date) {
      if (moment(date).isValid()) {
        return moment(date).format('YYYY-MM-DD');
      } else {
        return null;
      }
    },
    handlerGeetest(captchaObj) {
      let _this = this;
      $('#applyRealName').click(function() {
        captchaObj.verify();
      });
      captchaObj.onSuccess(function() {
        _this.handleCaptchaObjResult(captchaObj);
      });
      captchaObj.onClose(function() {
        _this.flagObj.authInfoStatus = false;
        _this.flagObj.realNameButtonLoading = false;
      });
      captchaObj.onError(function() {});
    },
    async handleCaptchaObjResult(captchaObj) {
      var result = captchaObj.getValidate();
      let params = {
        geetest_challenge: result['geetest_challenge'],
        geetest_validate: result['geetest_validate'],
        geetest_seccode: result['geetest_seccode'],
        searchword: this.orgInfo.creditCode,
        cookies: this.cookies
      };
      try {
        let res = await information(this.geetestUrl.information, params);
        res = res.data;
        if (res.returnCode === '00') {
          this.myApprovalInfo.departName = '未查询到信息';
        } else {
          Object.assign(this.myApprovalInfo, res.departInformation);
        }
      } catch (error) {
        this.myApprovalInfo.departName = '未查询到信息';
        this.$message.error(error.message);
      }
      // 跟新实名认证表
      this.saveRealName();
    },
    async realNamePayStatus() {
      try {
        let { data } = await queryPayInfo(this.departId, this.realNamePayInfo.orderType);
        if (data.returnCode === '01') {
          if (data.payInfo !== null) {
            if (data.payInfo.payStatus === '0') {
              // this.myApprovalInfo.departName = '未查询到信息';
              if (this.isGeest) {
                $('#applyRealName').click();
              } else {
                this.myApprovalInfo.departName = '未查询到信息';
                this.saveRealName();
              }
            } else {
              eventBus.$emit('orgRealNameAuthenticationConfirm', this.departId);
            }
          } else {
            eventBus.$emit('orgRealNameAuthenticationConfirm', this.departId);
          }
        } else {
          throw new Error('获取实名认证支付信息失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 显示微信支付对话框
    async showWeixinPayDialog() {
      // 初始化订单号
      // await this.initOrderNo();
      // 显示微信支付窗口
      this.weixinPay.isVisible = true;
      // 初始化微信支付二维码
      eventBus.$emit('initWeixinPayQRCode', {
        productId: this.realNamePayInfo.orderType,
        outTradeNo: this.sysOrderNumber,
        body: this.realNamePayInfo.content,
        price: this.authenticationTemplateInfo.price,
        desc: this.authenticationTemplateInfo.desc,
        orderParams: {
          orderType: this.realNamePayInfo.orderType,
          buyerOrgId: this.departId
        }
      });
    },
    // 保存支付信息
    async wxPaymentComplete(weixinPayInfo) {
      if (weixinPayInfo.status === 'SUCCESS') {
        this.isAuthing = true;
        this.weixinPay.isVisible = false;

        // this.flagObj.realNameButtonLoading = true;
        // this.flagObj.authInfoStatus = true;
        // this.realNamePayStatus();
        this.applyRealName();
      } else {
        this.$message.error('微信支付失败');
      }
    }
  }
};
</script>
<style scoped lang="less">
.eb-button-larger {
  width: 105px;
  height: 24px;
}
.weixinQRCodePayTitle {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  -webkit-font-smoothing: auto;
  .weixinQRCodePayTitle_left {
    line-height: 26px;
    height: 26px;
    overflow: hidden;
    color: #333;
    font-weight: 400;
    font-size: 14px;
    font-family: 'Microsoft Yahei';
    word-wrap: normal;
    margin-left: 30px;
  }
  .weixinQRCodePayTitle_right {
    font-family: Arial, Verdana;
    color: #666;
    font-size: 12px;
  }
  .weixinQRCodePayTitle_right_price {
    font-size: 18px;
    vertical-align: bottom;
    color: #e31613;
    margin: 0 3px;
    font-weight: bold;
    font-family: Arial, Verdana;
  }
}
</style>
